export default (state, action) => {
  const { stores } = action.payload;

  return {
    ...state,
    stores,
  };
};
